export default __webpack_public_path__ + "media/images/user_photos/38-df3cedcaa2235bf11cb1740053a0b52b.jpg";